<template>
    <div class="onHoldSec d-flex flex-column flex-lg-row align-items-center justify-content-start justify-content-lg-center position-relative w-100">
        <img class="img-fuid left dotsBg" src="../../../../static/fxView/images/registerflow-new/leftshape.png">
        <img class="img-fuid right dotsBg" src="../../../../static/fxView/images/registerflow-new/rightshape.png">
        <img class="img-fuid logo mx-auto d-block d-lg-none logoImg" src="../../../../static/fxView/images/registerflow-new/logo.svg">
        <div class="innerBox">
            <img class="img-fuid logo mb-4 mx-auto d-none d-lg-block" src="../../../../static/fxView/images/registerflow-new/logo.svg">
            <img class="img-fuid mb-3 theme mx-auto d-block mt-5" src="../../../../static/fxView/images/on-hold.png">
            <div class="subtitle text-center pb-1">
                <h3 class="mb-3 mt-2">Select Trading Account</h3>
                <p class="mb-3 lh-20">Explore risk-free with a Demo Account or dive into the real market with a Live Account.</p>
            </div>
            <div class="btnsSec d-flex align-items-center justify-content-center">
                <router-link :to="'/dashboard'" class="prism_btn stepsBtn mr-2">Go to Dashboard</router-link>
                <a href="#" class="prism_btn">Verify your Account</a>
            </div>
        </div>
    </div>
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
    export default {
        name: 'holdDeposit',
        mixins: [fxViewMixins],
        data() {
            return {
                acc_type: '',
            }
        },
        methods: {
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/deposit/hold_deposit.vue